import { awaitAllSafely } from '@vy/utils';
import { useQueryClient } from 'react-query';
import { useAnrokConnect } from '../../../../../../hooks/requests/integrations';
import { queryKeys } from '../../../../../../services/query-key/query-keys';
import { runMutation } from '../../../../../../utils/vy-mutation';
import { AnrokRegisterFormControl } from '../register-to-anrok';

export const useConnectToAnrok = (control: AnrokRegisterFormControl) => {
  const queryClient = useQueryClient();
  const { setError } = control;
  const mutateAsyncAnrokConnect = useAnrokConnect();
  return (apiKey: string, defaultExternalProductId: string) =>
    runMutation(
      mutateAsyncAnrokConnect,
      { apiKey, defaultExternalProductId },
      {
        pending: 'Connecting...',
        success: 'Connected',
        error: (toastProps) => (toastProps?.data as Error)?.message || 'Failed to connect',
      },
      {
        onError: (error) => {
          setError('apiKey', {
            type: 'manual',
            message: error instanceof Error ? error.message : 'Invalid API credentials',
          });
        },
        onSuccess: () =>
          awaitAllSafely(
            queryClient.invalidateQueries(queryKeys.connectedIntegrations()),
            queryClient.invalidateQueries(queryKeys.integrationSettings()),
          ),
      },
    );
};
